import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class FoodPageAdmin extends Component {
    constructor(props) {
      super(props);
      this.state = {
        foodPage: {},
        foodOpen: false,

        editMode: false,
        updated: Date().toLocaleString()
      };

      this.getFoodPage = this.getFoodPage.bind(this);

      this.setEditMode = this.setEditMode.bind(this);
      this.handleChangeText = this.handleChangeText.bind(this);

      this.handleSaveText = this.handleSaveText.bind(this);
      this.saveFoodPage = this.saveFoodPage.bind(this);
      this.toggleCheckbox = this.toggleCheckbox.bind(this);
      this.setUpdatedBy = this.setUpdatedBy.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getFoodPage();

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      this.setState({
        foodPage: Object.assign({}, this.state.foodPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getFoodPage() {
      try {
        fetch("/api/pagedata/getFoodPage", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        })
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data && data.length > 0) {
              this.setState({ foodPage: data[0] });
              this.setState({ foodOpen: data[0].foodOpen });
              this.setState({ foodOpenPost: data[0].foodOpenPost });
              this.setState({ noFoodSale: data[0].noFoodSale });
              this.setState({ noFoodSalePost: data[0].noFoodSalePost });
              this.setState({ foodClosedPost: data[0].foodClosedPost });

              this.setState({ food1Active: data[0].food1Active });
              this.setState({ food1Title: data[0].food1Title });
              this.setState({ food1Description: data[0].food1Description });
              this.setState({ food1Price: data[0].food1Price });

              this.setState({ food2Active: data[0].food2Active });
              this.setState({ food2Title: data[0].food2Title });
              this.setState({ food2Description: data[0].food2Description });
              this.setState({ food2Price: data[0].food2Price });

              this.setState({ food3Active: data[0].food3Active });
              this.setState({ food3Title: data[0].food3Title });
              this.setState({ food3Description: data[0].food3Description });
              this.setState({ food3Price: data[0].food3Price });

              this.setState({ food4Active: data[0].food4Active });
              this.setState({ food4Title: data[0].food4Title });
              this.setState({ food4Description: data[0].food4Description });
              this.setState({ food4Price: data[0].food4Price });

              this.setState({ food5Active: data[0].food5Active });
              this.setState({ food5Title: data[0].food5Title });
              this.setState({ food5Description: data[0].food5Description });
              this.setState({ food5Price: data[0].food5Price });

              this.setState({ updated: Date().slice(16, 24) });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    }

    async setEditMode() {
      if (this.state.editMode === false) {
        this.setState({ editMode: true });
      } else {
        this.setState({ editMode: false });
      }
      await this.getFoodPage();
    }

    async setUpdatedBy() {
      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      await this.setState({
        foodPage: Object.assign({}, this.state.foodPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    async saveFoodPage() {
      await this.setUpdatedBy();
      try {
        await authenticatedFetch("/api/admin/updateFoodPage", {
          method: "PUT",
          body: JSON.stringify(this.state.foodPage),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.setState({ editMode: false });
        window.scrollTo(0, 0);
      }
    }

    toggleCheckbox(event) {
      if (event.target.name === "foodOpen") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            foodOpen: event.target.checked
          })
        });
      } else if (event.target.name === "noFoodSale") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            noFoodSale: event.target.checked
          })
        });
      } else if (event.target.name === "food1Active") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food1Active: event.target.checked
          })
        });
      } else if (event.target.name === "food2Active") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food2Active: event.target.checked
          })
        });
      } else if (event.target.name === "food3Active") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food3Active: event.target.checked
          })
        });
      } else if (event.target.name === "food4Active") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food4Active: event.target.checked
          })
        });
      } else if (event.target.name === "food5Active") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food5Active: event.target.checked
          })
        });
      }
    }

    handleChangeText(event) {
      if (event.target.name === "foodClosedPost") {
        this.setState({
          foodClosedPost: event.target.value
        });
      } else if (event.target.name === "foodOpenPost") {
        this.setState({
          foodOpenPost: event.target.value
        });
      } else if (event.target.name === "noFoodSalePost") {
        this.setState({
          noFoodSalePost: event.target.value
        });
      } else if (event.target.name === "food1Title") {
        this.setState({
          food1Title: event.target.value
        });
      } else if (event.target.name === "food1Description") {
        this.setState({
          food1Description: event.target.value
        });
      } else if (event.target.name === "food1Price") {
        this.setState({
          food1Price: event.target.value
        });
      } else if (event.target.name === "food2Title") {
        this.setState({
          food2Title: event.target.value
        });
      } else if (event.target.name === "food2Description") {
        this.setState({
          food2Description: event.target.value
        });
      } else if (event.target.name === "food2Price") {
        this.setState({
          food2Price: event.target.value
        });
      } else if (event.target.name === "food3Title") {
        this.setState({
          food3Title: event.target.value
        });
      } else if (event.target.name === "food3Description") {
        this.setState({
          food3Description: event.target.value
        });
      } else if (event.target.name === "food3Price") {
        this.setState({
          food3Price: event.target.value
        });
      } else if (event.target.name === "food4Title") {
        this.setState({
          food4Title: event.target.value
        });
      } else if (event.target.name === "food4Description") {
        this.setState({
          food4Description: event.target.value
        });
      } else if (event.target.name === "food4Price") {
        this.setState({
          food4Price: event.target.value
        });
      } else if (event.target.name === "food5Title") {
        this.setState({
          food5Title: event.target.value
        });
      } else if (event.target.name === "food5Description") {
        this.setState({
          food5Description: event.target.value
        });
      } else if (event.target.name === "food5Price") {
        this.setState({
          food5Price: event.target.value
        });
      }
    }

    handleSaveText(event) {
      event.preventDefault();
      if (event.target.name === "foodClosedPostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            foodClosedPost: this.state.foodClosedPost
          })
        });
      } else if (event.target.name === "foodOpenPostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            foodOpenPost: this.state.foodOpenPost
          })
        });
      } else if (event.target.name === "noFoodSalePostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            noFoodSalePost: this.state.noFoodSalePost
          })
        });
      } else if (event.target.name === "food1TitleButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food1Title: this.state.food1Title
          })
        });
      } else if (event.target.name === "food1PostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food1Description: this.state.food1Description
          })
        });
      } else if (event.target.name === "food1PriceButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food1Price: this.state.food1Price
          })
        });
      } else if (event.target.name === "food2TitleButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food2Title: this.state.food2Title
          })
        });
      } else if (event.target.name === "food2PostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food2Description: this.state.food2Description
          })
        });
      } else if (event.target.name === "food2PriceButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food2Price: this.state.food2Price
          })
        });
      } else if (event.target.name === "food3TitleButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food3Title: this.state.food3Title
          })
        });
      } else if (event.target.name === "food3PostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food3Description: this.state.food3Description
          })
        });
      } else if (event.target.name === "food3PriceButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food3Price: this.state.food3Price
          })
        });
      } else if (event.target.name === "food4TitleButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food4Title: this.state.food4Title
          })
        });
      } else if (event.target.name === "food4PostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food4Description: this.state.food4Description
          })
        });
      } else if (event.target.name === "food4PriceButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food4Price: this.state.food4Price
          })
        });
      } else if (event.target.name === "food5TitleButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food5Title: this.state.food5Title
          })
        });
      } else if (event.target.name === "food5PostButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food5Description: this.state.food5Description
          })
        });
      } else if (event.target.name === "food5PriceButton") {
        this.setState({
          foodPage: Object.assign({}, this.state.foodPage, {
            food5Price: this.state.food5Price
          })
        });
      }
    }

    render() {
      if (this.props.authenticated === null) return null;

      return (
        <div className="SignupList">
          <h1>Matsiden</h1>
          <button
            className={
              "btn btno edit  " +
              (this.state.editMode ? "btn-info" : "btn-danger")
            }
            onClick={this.setEditMode}
          >
            {this.state.editMode ? "Lås" : "Rediger"}
          </button>
          <button
            className="btn btno btn-success edit  "
            onClick={() => this.getFoodPage()}
          >
            Refresh
          </button>

          <hr />
          <h1 className="center">Generelt</h1>

          <form className="dateFieldsContainer center">
            <div>
              <div className="center">
                <h6>Matside åpen?</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="foodOpen"
                  defaultChecked={this.state.foodPage && this.state.foodPage.foodOpen}
                  onClick={this.toggleCheckbox}
                />
              </div>
            </div>

            <div>
              <div className="center">
                <h6>Ingen matsalg?</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="noFoodSale"
                  defaultChecked={this.state.foodPage && this.state.foodPage.noFoodSale}
                  onClick={this.toggleCheckbox}
                />
              </div>
            </div>

            <div>
              <h5 className="center">Matside er åpen - post:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.foodOpenPost : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="foodOpenPost"
                      value={this.state.foodOpenPost}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="foodOpenPostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>

            <div>
              <h5 className="center">Matside er stengt - post:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.foodClosedPost : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="foodClosedPost"
                      value={this.state.foodClosedPost}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="foodClosedPostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>

            <div>
              <h5 className="center">Ingen matsalg - post:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.noFoodSalePost : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="noFoodSalePost"
                      value={this.state.noFoodSalePost}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="noFoodSalePostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>
          </form>

          <hr />

          <br></br>
          <br></br>
          <br></br>

          <form className="dateFieldsContainer center">
            <h1 className="center">Matrett 1</h1>

            <div>
              <div className="center">
                <h6>Matrett 1 aktiv:</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="food1Active"
                  defaultChecked={this.state.foodPage && this.state.foodPage.food1Active}
                  onClick={this.toggleCheckbox}
                />
              </div>
            </div>

            <h5 className="center">Matrett 1 - tittel:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food1Title : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food1Title"
                    value={this.state.food1Title}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food1TitleButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}

            <div>
              <h5 className="center">Matrett 1 - beskrivelse:</h5>
              <div
                className="infoCard"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.food1Description : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="food1Description"
                      value={this.state.food1Description}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="food1PostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>

            <h5 className="center">Matrett 1 - pris:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food1Price : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food1Price"
                    value={this.state.food1Price}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food1PriceButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}
          </form>

          <hr />

          <br></br>
          <br></br>
          <br></br>

          <form className="dateFieldsContainer center">
            <h1 className="center">Matrett 2</h1>

            <div>
              <div className="center">
                <h6>Matrett 2 aktiv:</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="food2Active"
                  defaultChecked={this.state.foodPage && this.state.foodPage.food2Active}
                  onClick={this.toggleCheckbox}
                />
              </div>
            </div>

            <h5 className="center">Matrett 2 - tittel:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food2Title : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food2Title"
                    value={this.state.food2Title}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food2TitleButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}

            <div>
              <h5 className="center">Matrett 2 - beskrivelse:</h5>
              <div
                className="infoCard"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.food2Description : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="food2Description"
                      value={this.state.food2Description}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="food2PostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>

            <h5 className="center">Matrett 2 - pris:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food2Price : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food2Price"
                    value={this.state.food2Price}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food2PriceButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}
          </form>

          <br></br>
          <br></br>
          <br></br>

          <hr />

          <form className="dateFieldsContainer center">
            <h1 className="center">Matrett 3</h1>

            <div>
              <div className="center">
                <h6>Matrett 3 aktiv:</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="food3Active"
                  defaultChecked={this.state.foodPage && this.state.foodPage.food3Active}
                  onClick={this.toggleCheckbox}
                />
              </div>
            </div>

            <h5 className="center">Matrett 3 - tittel:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food3Title : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food3Title"
                    value={this.state.food3Title}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food3TitleButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}

            <div>
              <h5 className="center">Matrett 3 - beskrivelse:</h5>
              <div
                className="infoCard"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.food3Description : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="food3Description"
                      value={this.state.food3Description}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="food3PostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>

            <h5 className="center">Matrett 3 - pris:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food3Price : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food3Price"
                    value={this.state.food3Price}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food3PriceButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}
          </form>

          <br></br>
          <br></br>
          <br></br>

          <hr />
          <form className="dateFieldsContainer center">
            <h1 className="center">Matrett 4</h1>

            <div>
              <div className="center">
                <h6>Matrett 4 aktiv:</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="food4Active"
                  defaultChecked={this.state.foodPage && this.state.foodPage.food4Active}
                  onClick={this.toggleCheckbox}
                />
              </div>
            </div>

            <h5 className="center">Matrett 4 - tittel:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food4Title : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food4Title"
                    value={this.state.food4Title}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food4TitleButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}

            <div>
              <h5 className="center">Matrett 4 - beskrivelse:</h5>
              <div
                className="infoCard"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.food4Description : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="food4Description"
                      value={this.state.food4Description}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="food4PostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>

            <h5 className="center">Matrett 4 - pris:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food4Price : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food4Price"
                    value={this.state.food4Price}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food4PriceButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}
          </form>

          <br></br>
          <br></br>
          <br></br>

          <hr />
          <form className="dateFieldsContainer center">
            <h1 className="center">Matrett 5</h1>

            <div>
              <div className="center">
                <h6>Matrett 5 aktiv:</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="food5Active"
                  defaultChecked={this.state.foodPage && this.state.foodPage.food5Active}
                  onClick={this.toggleCheckbox}
                />
              </div>
            </div>

            <h5 className="center">Matrett 5 - tittel:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food5Title : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food5Title"
                    value={this.state.food5Title}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food5TitleButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}

            <div>
              <h5 className="center">Matrett 5 - beskrivelse:</h5>
              <div
                className="infoCard"
                dangerouslySetInnerHTML={{
                  __html: this.state.foodPage ? this.state.foodPage.food5Description : ''
                }}
              />
              {this.state.editMode === true && (
                <span>
                  <div className="card">
                    <textarea
                      name="food5Description"
                      value={this.state.food5Description}
                      onChange={this.handleChangeText}
                    />
                  </div>
                  <button
                    name="food5PostButton"
                    className="btn btno btn-warning edit center"
                    onClick={this.handleSaveText}
                  >
                    Oppdater forhåndsvisning
                  </button>
                </span>
              )}
            </div>

            <h5 className="center">Matrett 5 - pris:</h5>
            <div
              className="card"
              dangerouslySetInnerHTML={{
                __html: this.state.foodPage ? this.state.foodPage.food5Price : ''
              }}
            />
            {this.state.editMode === true && (
              <span>
                <div className="card center">
                  <input
                    type="text"
                    className="dateFields"
                    name="food5Price"
                    value={this.state.food5Price}
                    onChange={this.handleChangeText}
                  />
                </div>
                <button
                  name="food5PriceButton"
                  className="btn btno btn-warning edit center"
                  onClick={this.handleSaveText}
                >
                  Oppdater forhåndsvisning
                </button>
              </span>
            )}
          </form>

          <br></br>
          <br></br>
          <br></br>

          <hr />
          {this.state.editMode === true && (
            <div>
              <button
                className="btn btno btn-danger edit center"
                onClick={this.saveFoodPage}
              >
                Lagre til server
              </button>
            </div>
          )}
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/Admin/FoodPageAdmin.js